import ListPage, { TListPage } from 'components/ListPage';
import * as baseConfig from 'schemas/eventRequesters';

const RequestersTab = (props: Partial<TListPage>) => {
  return <ListPage {...props} entityName="invitedRequester" {...baseConfig} allowRowClick={false} />;
};

export default RequestersTab;
